import * as $runtime from "../runtime.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dSemiring from "../Data.Semiring/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const itemValue = v => Data$dInt.toNumber(v.price) / 100.0 * Data$dInt.toNumber(v.quantity);
const itemToContent = v => ({id: v.name, quantity: v.quantity});
const toPlatformEvent = currency => v => {
  if (v.tag === "AddToCart") {
    return Data$dMaybe.$Maybe(
      "Just",
      {
        name: "AddToCart",
        value: Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
          reflectSymbol: () => "value"
        })({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "currency"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({
          reflectSymbol: () => "contents"
        })((() => {
          const $0 = Data$dFunctor.arrayMap(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
            reflectSymbol: () => "quantity"
          })({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "id"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions));
          return {encodeWithOptions: v$1 => $0};
        })()))({reflectSymbol: () => "content_type"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)({
          content_type: "product",
          contents: [{id: v._1.name, quantity: v._1.quantity}],
          value: Data$dInt.toNumber(v._1.price) / 100.0 * Data$dInt.toNumber(v._1.quantity),
          currency
        })
      }
    );
  }
  if (v.tag === "LocateMe") { return Data$dMaybe.Nothing; }
  if (v.tag === "RemoveFromCart") { return Data$dMaybe.Nothing; }
  if (v.tag === "BeginCheckout") {
    return Data$dMaybe.$Maybe(
      "Just",
      {
        name: "InitiateCheckout",
        value: Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
          reflectSymbol: () => "value"
        })({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "num_items"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({
          reflectSymbol: () => "currency"
        })({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "contents"})((() => {
          const $0 = Data$dFunctor.arrayMap(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
            reflectSymbol: () => "quantity"
          })({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "id"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions));
          return {encodeWithOptions: v$1 => $0};
        })()).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)({
          contents: Data$dFunctor.arrayMap(itemToContent)(v._1.items),
          value: Data$dFoldable.foldlArray(Data$dSemiring.numAdd)(0.0)(Data$dFunctor.arrayMap(itemValue)(v._1.items)),
          num_items: Data$dFoldable.foldlArray(c => v$1 => 1 + c | 0)(0)(v._1.items),
          currency
        })
      }
    );
  }
  if (v.tag === "Purchase") {
    return Data$dMaybe.$Maybe(
      "Just",
      {
        name: "Purchase",
        value: Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
          reflectSymbol: () => "value"
        })({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "currency"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({
          reflectSymbol: () => "contents"
        })((() => {
          const $0 = Data$dFunctor.arrayMap(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
            reflectSymbol: () => "quantity"
          })({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "id"})({encodeWithOptions: v$1 => Unsafe$dCoerce.unsafeCoerce}).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions));
          return {encodeWithOptions: v$1 => $0};
        })()).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)({
          contents: Data$dFunctor.arrayMap(itemToContent)(v._1.items),
          value: Data$dInt.toNumber(v._1.total) / 100.0,
          currency
        })
      }
    );
  }
  if (v.tag === "SetCheckoutOption") { return Data$dMaybe.Nothing; }
  $runtime.fail();
};
export {itemToContent, itemValue, toPlatformEvent};
